var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("p", { staticStyle: { "font-weight": "bold", "font-size": "16px" } }, [
        _vm._v("站点商品数据爬虫"),
      ]),
      _c(
        "div",
        [
          _c(
            "el-input",
            {
              staticClass: "input",
              attrs: { placeholder: "请输入站点链接" },
              model: {
                value: _vm.params.url,
                callback: function ($$v) {
                  _vm.$set(_vm.params, "url", $$v)
                },
                expression: "params.url",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "110px" },
                  attrs: { slot: "prepend", placeholder: "请选择" },
                  slot: "prepend",
                  model: {
                    value: _vm.params.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "type", $$v)
                    },
                    expression: "params.type",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "店匠", value: "18" } }),
                  _c("el-option", { attrs: { label: "Shopify", value: "7" } }),
                  _c("el-option", {
                    attrs: { label: "Shopline", value: "19" },
                  }),
                  _c("el-option", {
                    attrs: { label: "Xshoppy ", value: "22" },
                  }),
                  _c("el-option", {
                    attrs: { label: "Bigcommerce", value: "21" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "16px" },
              attrs: { type: "primary", disabled: !!_vm.timer },
              on: { click: _vm.search },
            },
            [_vm._v(" " + _vm._s(!!_vm.timer ? "爬取中" : "爬取") + " ")]
          ),
          !!_vm.timer
            ? _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.stopSpider } },
                [_vm._v("停止爬取")]
              )
            : _vm._e(),
        ],
        1
      ),
      !!_vm.timer
        ? _c("div", { staticClass: "loading" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _c("span", [_vm._v("爬取数据需要等待一段时间，请耐心等待…")]),
          ])
        : _vm._e(),
      _c(
        "el-table",
        {
          staticStyle: { "margin-top": "29px" },
          attrs: { data: _vm.data, "max-height": 400 },
          on: { "sort-change": _vm.sortChange },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "spuId", label: "spuId", "min-width": "130" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "productName",
              label: "商品名称",
              "min-width": "130",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "imageUrl", label: "图片", "min-width": "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.imageUrl
                      ? _c("img", {
                          staticStyle: { width: "40px", height: "40px" },
                          attrs: { src: row.imageUrl },
                        })
                      : _c("span", [_vm._v("--")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "category", label: "品类", "min-width": "130" },
          }),
          _c("el-table-column", {
            attrs: { prop: "currency", label: "币种", "min-width": "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "price", label: "价格", "min-width": "130" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              width: "130",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "publishTime",
              label: "发布时间",
              width: "130",
              sortable: "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "updateTimeupdateTime",
              label: "更新时间",
              width: "130",
              sortable: "",
            },
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { "align-self": "flex-end", "margin-top": "16px" },
        attrs: {
          "current-page": _vm.pagination.pageNum,
          "page-size": _vm.pagination.pageSize,
          layout: "total, prev, pager, next",
          total: _vm.pagination.total,
        },
        on: { "current-change": _vm.handleCurrentChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }